import React from 'react'
import { Card, Col, List, Row, Typography } from 'antd'
import { map } from 'lodash'
import PropTypes from 'prop-types'

import { formatDateFromNow } from '../../../core/utils'

const { Item } = List
const { Text, Title } = Typography

const transformData = ({ version, accuracy, deployedAt }) => [
  { title: 'Version: ', text: version },
  { title: 'Accuracy: ', text: accuracy ? Number(accuracy).toFixed(2) : '-' },
  {
    title: 'Deployed at: ',
    text: deployedAt ? formatDateFromNow(deployedAt) : '-',
  },
]

const ProductInfoCards = ({ data }) => (
  <Row gutter={[16, 16]}>
    {map(data, ({ type, ...rest }, index) => (
      <Col xs={24} sm={12} md={12} lg={6} xl={6} key={index}>
        <Card>
          <List
            size="small"
            header={<Title level={4}>{type}</Title>}
            dataSource={transformData(rest)}
            renderItem={({ title, text }) => (
              <Item>
                <Text strong>{title}</Text> <Text>{text}</Text>
              </Item>
            )}
          />
        </Card>
      </Col>
    ))}
  </Row>
)

ProductInfoCards.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      version: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      accuracy: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      deployedAt: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
      ]),
    }),
  ),
}

ProductInfoCards.defaultProps = {
  data: [],
}

export default ProductInfoCards
